import ConnectStores from "lib/core/store/components/ConnectStores"
import "./ResourceTrailer.css"

const ResourceTrailer = function ({ resource }) {
  if (!resource) {
    return null
  }

  return (
    <div
      className="ResourceTrailer"
      dangerouslySetInnerHTML={{ __html: resource.trailer_embed_code }}
    />
  )
}

ResourceTrailer.displayName = "ResourceTrailer"

const mapStateToProps = function (state, ownProps) {
  const { resource } = state.resourceStore.state

  return _.assign(
    {},
    {
      resource
    },
    ownProps
  )
}

const stores = [{ store: "resource", watch: ["resource"] }]

export default ConnectStores(ResourceTrailer, stores, {}, mapStateToProps)
